!function(n,e){"object"==typeof exports&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define("v-click-outside",e):n["v-click-outside"]=e()}(this,function(){"use strict";var n={};return n.onEvent=function(e){e.target===this.el||this.el.contains(e.target)||n.cb&&n.cb(e)},n.bind=function(e){n.onEventBound=n.onEvent.bind({el:e}),document.addEventListener("click",n.onEventBound)},n.update=function(e,t){if("function"!=typeof t.value)throw new Error("Argument must be a function");n.cb=t.value},n.unbind=function(){document.removeEventListener("click",n.onEventBound)},{install:function(e){e.directive("click-outside",n)}}});



//////////////////
// WEBPACK FOOTER
// ./~/v-click-outside/dist/v-click-outside.min.js
// module id = 280
// module chunks = 1